import { getCustomTag, sendNotification, useTranslation } from '@msdk/common'
import { DefaultActionsDetails, DefaultActionType, EntityOperation, ServerOperationResult } from '@msdk/definitions'
import { ButtonIcon, ButtonSecondary, IconSelector, styled, Tooltip } from '@msdk/ui'
import React from 'react'

import { useComponentModal } from '../../hooks'
import { messagesFromEntityOperation } from '../../utils'
import { ActionConfirmationModal } from '../ActionConfirmationModal'
import { ActionLabels, getActivateActionLabels } from '../DynamicView/RowActions/labels-utils'
import { ActionVisualizationMode } from './action-visualization'
import { ActionMenuItem, ActionMenuText } from './ActionMenuItem'

const ActivateButtonStyled = styled(ButtonSecondary)`
  margin-right: 5px;
`
const StyledButtonIcon = styled(ButtonIcon)`
  padding: 4px;
  color: ${({ theme }) => theme.palette.primary.main};
`
interface Props {
  onRestore: () => Promise<EntityOperation>
  visualizationMode: ActionVisualizationMode
  onClose?: () => void
  actionDetails?: DefaultActionsDetails
}

export function ActivateAction(props: Props) {
  const t = useTranslation()
  const { createModal } = useComponentModal()

  const labels: ActionLabels = getActivateActionLabels(props.actionDetails, t)

  const handleClick = async () => {
    props.onClose && props.onClose()

    const onConfirm = async () => {
      const res = await props.onRestore()

      const serverMessages = messagesFromEntityOperation(res)

      if (serverMessages.length) {
        if (serverMessages.length) {
          const translated = serverMessages.reduce((acc, curr) => (acc += `\n${t(curr.idml, curr.description)}`), '')
          sendNotification({ message: translated, status: 'error' })
        }
      } else {
        if (res.result == ServerOperationResult.Success) {
          sendNotification({ message: labels.success, status: 'success' })
        } else {
          sendNotification({ message: labels.error, status: 'error' })
        }
      }
    }

    const modalRef = createModal(
      <ActionConfirmationModal
        title={labels.title}
        body={labels.body}
        onConfirm={onConfirm}
        confirmationLabel={labels.confirmationLabel}
        type={DefaultActionType.Activate}
      />,
      () => {
        //do nothing
      },
    )

    modalRef.open()
  }

  return (
    <>
      {props.visualizationMode === 'SingleAction' && (
        <Tooltip title={labels.description} arrow>
          <StyledButtonIcon onClick={handleClick}>
            {labels.iconTag && <IconSelector iconName={labels.iconTag} />}
            {!labels.iconTag && labels.description}
          </StyledButtonIcon>
        </Tooltip>
      )}
      {props.visualizationMode === 'Buttons' && (
        <ActivateButtonStyled
          onClick={handleClick}
          key="ACTIVATE"
          data-test-id={getCustomTag(['FORM', 'ACTIVATE', 'button'])}
        >
          {labels.description}
        </ActivateButtonStyled>
      )}
      {props.visualizationMode === 'MenuItems' && (
        <ActionMenuItem onClick={handleClick} data-test-id={getCustomTag(['FORM', 'ACTIVATE', 'button'])}>
          <IconSelector iconName={labels.iconTag} />
          <ActionMenuText>{labels.description}</ActionMenuText>
        </ActionMenuItem>
      )}
    </>
  )
}
